import React from "react";
import { connect } from "react-redux";
import "../Forms/css/register.css";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class EditLocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      pincode: '', // Add pincode state to store comma-separated pin codes
      submissionStatus: null,
      id: null,
    };
  }
  
  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
    } else {
      console.error("No match or id found in props");
    }
  }

  fetchData = async (id) => {
    console.log("Fetch data called with id:", id);
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/superadmin/locations/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const locationData = response?.data;
      console.log("Fetch data response:", locationData);
      if (locationData) {
        this.setState({
          name: locationData?.name || '',
          pincode: locationData?.pincode || '', // Initialize pincode with fetched data
        });
      } else {
        console.error("No location data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id, name, pincode } = this.state;

    const jsonData = { name, pincode };

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      };

      const response = await axios.put(`https://brand.aasmo.in/api/superadmin/locations/${id}`, jsonData, config);

      console.log('Response:', response);

      if (response && response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        console.log('Form submitted successfully');
        setTimeout(() => {
          this.props.history.push('/list-location');
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
      }
    } catch (error) {
      console.error('Error submitting form:', error);

      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          console.error('Bad request error:', data);
        } else if (status === 401) {
          console.error('Unauthorized error, please log in again.');
        } else {
          console.error('Error response:', error.response);
        }
      } else {
        console.error('Network or other error:', error);
      }
    }
  };

  render() {
    const { name, pincode, submissionStatus } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Edit Location</h2>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={name}
                      onChange={this.handleChange}
                      placeholder="Location Name"
                    />
                  </div>
                  <div className="form-group">
                    <label>Pin Codes (comma separated)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="pincode"
                      value={pincode}
                      onChange={this.handleChange}
                      placeholder="Enter pin codes separated by commas"
                    />
                  </div>
                  {submissionStatus === 'success' && (
                    <div className="alert alert-success" role="alert">
                      Form submitted successfully!
                    </div>
                  )}
                  <button
                    className="btn btn-primary"
                    onClick={(e) => {
                      this.setState({ submit: true });
                      this.handleSubmit(e);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default withRouter(connect(mapStateToProps)(EditLocation));
